module.exports = __webpack_public_path__ + "img/qrcode.f5ccff7b.png";